import { DateOfBirthDateOfDeath } from '../../../Components/DateOfBirthDateOfDeath';
import { FuneralService } from '../../../types';
import ServiceAdditionalLinks from '../ServiceStyle1/Partials/ServiceAdditionalLinks';
import { ServiceSheetButton } from '../Shared/ServiceSheetButton';
import { Header2 } from './Header2';
import ServiceEvents2 from './ServiceEvents2';

const ServiceTitle = ({ service }) => (
  <h2 className="service-title">
    {service.serviceName.map((formatted) =>
      formatted?.key ? (
        <span key={formatted?.key} className={'service-title-' + formatted?.key}>
          {formatted?.text}
        </span>
      ) : null,
    )}
  </h2>
);

export const ServiceDetails2 = ({ service, shareUrl, isLive }: { service?: FuneralService; shareUrl: string; isLive: boolean }) => {
  const isMobile = window.innerWidth < 1270;
  return (
    <div className="details-container-2">
      <Header2 service={service} isLive={isLive} shareUrl={shareUrl} />
      {!isMobile ? (
        service?.profile_photo_url ? (
          <img className="details-image-2" src={service?.profile_photo_url} alt={service?.name} />
        ) : (
          <div className="no-image"></div>
        )
      ) : null}
      <div className="main-details-2">
        <DateOfBirthDateOfDeath dateOfBirth={service?.date_of_birth} dateOfDeath={service?.date_of_death} format={service?.date_format} />
        <ServiceTitle service={service} />
        {isMobile ? (
          service?.profile_photo_url ? (
            <img className="details-image-2" src={service?.profile_photo_url} alt={service?.name} />
          ) : (
            <div className="no-image"></div>
          )
        ) : null}
        <div className="service-description" dangerouslySetInnerHTML={{ __html: service?.description ?? '' }} />
        {service?.service_sheet_link && <ServiceSheetButton link={service?.service_sheet_link} />}
        <ServiceEvents2 events={service?.events} service={service!} />
        <ServiceAdditionalLinks additionalLinks={service?.additional_links} />
      </div>
    </div>
  );
};
